import { message } from 'antd';
import { strings } from '../../../constants/strings';

const defaultMessage = {
  error: strings?.something_went_wrong,
  success: strings?.action_completed_successfully,
  warning: strings?.potential_issue,
  info: strings?.fyi,
};

const renderToast =
  (type) =>
  (
    msg = defaultMessage[type],
    duration = 3
  ) =>
    msg && message[type](msg, duration);

const Toast = {
  error: renderToast('error'),
  success: renderToast('success'),
  info: renderToast('info'),
  warning: renderToast('warning'),
};

export default Toast;
